import React from 'react'

import { useSettingItems } from './lib'
import { useTranslation } from 'language/translator'

import ContentBox from 'components_new/molecules/ContentBox'
import GenericListItem from 'components_new/molecules/GenericListItem'
import SectionHeader from 'components_new/molecules/SectionHeader'

import PageLayout from 'components_new/templates/PageLayout'

const SettingsLanding = () => {
  const settingItems = useSettingItems()

  const { t } = useTranslation()

  return (
    <PageLayout
      topbar={{ breadcrumbs: [{ title: t('global', 'settings') }] }}
      content={{ size: 'large' }}
      variant="feed"
    >
      <SectionHeader
        body={t('settings', 'page_body')}
        size="large"
        sx={{ mb: 2 }}
        title={t('settings', 'page_title')}
      />

      <ContentBox border={true} disablePadding={true}>
        {settingItems.map((settingItem, i) => (
          <GenericListItem
            action="to"
            body={settingItem.body}
            chip={
              settingItem.disabled
                ? { label: settingItem.disabledTitle }
                : undefined
            }
            disabled={settingItem.disabled}
            key={i}
            icon={settingItem.icon}
            title={settingItem.name}
            to={settingItem.href}
          />
        ))}
      </ContentBox>
    </PageLayout>
  )
}

export default SettingsLanding
